const sandboxRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/sandbox/explore',
        name: 'sandboxExplore',
        component: () => import('./views/Sandbox.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'sandbox' },
            { title: 'explore', active: true },
          ],
          pageTitle: 'Explore',
          rule: 'editor'
        }
      }
    ]
  }
];

export default sandboxRoutes;
